import { render, staticRenderFns } from "./modalOcorrTrans.vue?vue&type=template&id=2a0d2984&scoped=true"
import script from "./modalOcorrTrans.vue?vue&type=script&lang=js"
export * from "./modalOcorrTrans.vue?vue&type=script&lang=js"
import style0 from "./modalOcorrTrans.vue?vue&type=style&index=0&id=2a0d2984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d2984",
  null
  
)

export default component.exports